@if (label != null) {
  <label>{{ label }}</label>
}
<mat-form-field class="am-form-field" appearance="fill" *transloco="let t">
  <mat-select
    multiple
    disableRipple="true"
    [formControl]="multiSelectCtrl"
    #select
    panelClass="multi-select-with-search"
  >
    <div class="actions">
      <am-search-multiselect
        [formControl]="searchCtrl"
        [parentHasBeenReset]="parentHasBeenReset$"
        [placeholderLabel]="t('shared.multi-select-with-search.search')"
        [parentHasBeenToggled]="toggleOptions$"
      ></am-search-multiselect>
      <mat-checkbox class="toggle-btn" [checked]="toggleOptions$ | async" (change)="toggleAll()"></mat-checkbox>
    </div>
    <div class="option-list">
      @for (option of filteredOptions$ | async; track option) {
        <mat-option [value]="option.value">
          {{ option.label ? option.label : option.value }}
        </mat-option>
      }
    </div>
  </mat-select>
</mat-form-field>
